<template lang="pug">
  #app(ontouchstart="")
    component(:is="layout")
    b-loading(:is-full-page="isFullPage" v-model="this.$store.state.isLoading")
</template>

<script>
export default {
    name: 'app',
    data() {
      return {
        noneLayout: "none",
        isFullPage: true
      }
    },
    computed: {
      layout() {
          return (this.$route.meta.layout || this.noneLayout) + '-layout';
      }
    },
  }
</script>

<style>
  @import "https://unicons.iconscout.com/release/v2.1.11/css/unicons.css";
</style>